import { ProductVariantDetails } from '@/models/product-variant-details/product-variant-details';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ConfigService } from '@services/config.service';
declare var bootstrap: any;

@Component({
  selector: 'app-free-stage-entry-page',
  templateUrl: './free-stage-entry-page.component.html',
  styleUrl: './free-stage-entry-page.component.scss'
})
export class FreeStageEntryPageComponent implements OnInit {
  searchText: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  getAllVariantDetails: ProductVariantDetails[] = [];
  endpoint: string = "";
  selectedVariant: any = null;
  private imageModal: any;
  getImageId: number = 0;
  isItemsModalOpen: boolean = false;
  getAllVariantDetailsByProductId: ProductVariantDetails[] = [];
  filteredVariantDetails: ProductVariantDetails[] = [];
  private searchSubject = new Subject<string>();

  constructor(
    private router: Router,
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private config: ConfigService
  ) {
  }

  ngOnInit() {
    this.endpoint = this.config.getConfig().END_POINT;
     this.searchSubject
    .pipe(
      debounceTime(250),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
    .subscribe(searchText => {
      this.filterVariants(searchText);
    });

  this.getProductVariantDetails();
  }

  // get product details
  getProductVariantDetails() {
    this.spinner.show();
    this.appService.getAllFreeStageVariant()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: ProductVariantDetails[]) => {
        this.spinner.hide();
        this.getAllVariantDetails = data.filter(item => item.isAvailable === true).sort((a, b) => b.productVariantId - a.productVariantId);
        this.filteredVariantDetails = this.getAllVariantDetails;
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.message || "Something went wrong, please try again...")
      });
  }

  openImageModal(item: any) {
    this.selectedVariant = item;
    this.variantIdBasedImageDetailsGetting(item.productVariantId)
    const modalElement = document.getElementById('imagePreviewModal');

    if (!this.imageModal) {
      this.imageModal = new bootstrap.Modal(modalElement);
    }

    this.imageModal.show();
  }

  openItemsModal(productId: number) {
    this.getVariantByProductId(productId)
    this.isItemsModalOpen = true;
    document.body.style.overflow = 'hidden';
  }

  filterVariants(searchText: string): void {

  const search = searchText
    .trim()
    .toLowerCase();

  // Show all records when search is empty
  if (!search) {
    this.filteredVariantDetails = this.getAllVariantDetails;
    return;
  }

  this.filteredVariantDetails = this.getAllVariantDetails.filter(item => {

    const productName = (item.productName || '').toString().toLowerCase();
    const barcode = (item.barcodeNumber || '').toString().toLowerCase();
    const size = (item.size || '').toString().toLowerCase();

    return (
      productName.includes(search) ||
      barcode.includes(search) ||
      size.includes(search)
    );

  });

}

onSearchChange(event: Event): void {

  const input = event.target as HTMLInputElement;

  this.searchSubject.next(input.value);
}

  getVariantByProductId(productId: number) {
    this.spinner.show();
    this.appService.getVariantByProductId(productId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: ProductVariantDetails[]) => {
        this.spinner.hide();
        this.getAllVariantDetailsByProductId = data.filter(item => item.isAvailable === true && item.availableStock != 0).sort((a, b) => b.productVariantId - a.productVariantId);
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.message || "Something went wrong, please try again...")
      });
  }

  closeItemsModal() {
    this.isItemsModalOpen = false;
    this.getAllVariantDetailsByProductId = [];
  }


  variantIdBasedImageDetailsGetting(variantId: number) {
    this.getImageId = 0;
    this.spinner.show();
    this.appService.variantIdBasedImageDetailsGetting(variantId).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        this.getImageId = res.imageDetailsId
      },
      error: () => {
        this.spinner.hide();
        // this.toastr.error('Bulk update failed');
      }
    });
  }

  getImageById(imageId: number): string {
    return imageId
      ? `${this.endpoint}/api/product/image-details/get/${imageId}`
      : 'assets/img/my-1.jpg';
  }


  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }


  updateFreezeStage(item: any, status: string) {
    const qty = 1;

    // Validation
    if (!qty || qty <= 0) {
      this.toastr.warning('Enter valid quantity');
      return;
    }

    // Cannot freeze more than available
    if (qty > item.availableStock && qty > item.reservedQuantity) {
      this.toastr.error('Quantity exceeds available or freeze stock');
      return;
    }

    //FREEZE

    if (status == 'Freeze') {
      if (qty > item.availableStock) {
        this.toastr.error('Cannot freeze more than available stock');
        return;
      }
      this.freezeQuantity(item, qty);
    } else if (status == 'Unfreeze') {
      // UNFREEZE
      if (qty > item.reservedQuantity) {
        this.toastr.error('Cannot unfreeze more than freeze stock');
        return;
      }
      this.unfreezeQuantity(item, qty);
    }

    // // Single SweetAlert for both actions
    // Swal.fire({
    //   title: 'Choose Action',
    //   html: `
    //   Entered Quantity: <b>${qty}</b><br>
    //   Frozen: <b>${item.reservedQuantity}</b><br>
    //   Available Stock: <b>${item.availableStock}</b>
    // `,
    //   icon: 'question',
    //   showCancelButton: true,
    //   showDenyButton: true,
    //   confirmButtonText: 'Freeze',
    //   denyButtonText: 'Unfreeze',
    //   cancelButtonText: 'Cancel',
    //   confirmButtonColor: '#28a745',
    //   denyButtonColor: '#dc3545'
    // }).then(result => {

    //   if (result.isConfirmed) {
    //     // FREEZE
    //     if (qty > item.availableStock) {
    //       this.toastr.error('Cannot freeze more than available stock');
    //       return;
    //     }
    //     this.freezeQuantity(item, qty);
    //   }

    //   if (result.isDenied) {
    //     // UNFREEZE
    //     if (qty > item.reservedQuantity) {
    //       this.toastr.error('Cannot unfreeze more than frozen stock');
    //       return;
    //     }
    //     this.unfreezeQuantity(item, qty);
    //   }

    //   // Cancel does nothing
    // });
  }



  freezeQuantity(item: any, qty: number) {

    this.spinner.show();

    this.appService.freezeStageDetails(item.productVariantId, qty)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.spinner.hide();

          item.availableStock -= qty;
          item.reservedQuantity += qty;
          item.inputQty = null;

          this.toastr.success('Stock freeze successfully');
        },
        error: (err) => {
          this.spinner.hide();
          this.toastr.error(err.error?.message || 'Freeze failed');
        }
      });
  }


  unfreezeQuantity(item: any, qty: number) {

    // Safety check
    if (qty > item.reservedQuantity) {
      this.toastr.error('Cannot unfreeze more than freeze quantity');
      return;
    }

    this.spinner.show();

    this.appService.unfreezeStageDetails(item.productVariantId, qty)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.spinner.hide();

          item.availableStock += qty;
          item.reservedQuantity -= qty;
          item.inputQty = null;

          this.toastr.success('Stock unfreeze successfully');
        },
        error: (err) => {
          this.spinner.hide();
          this.toastr.error(err.error?.message || 'Unfreeze failed');
        }
      });
  }


  downloadExcel() {
    try {
      this.spinner.show();

      const data = this.getDownloadData();

      if (!data.length) {
        this.toastr.warning('No valid data available to download');
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(data);

      XLSX.utils.sheet_add_aoa(worksheet, [[
        'Product Name',
        'Barcode',
        'Actual Quantity',
        'Current Quantity',
        'Reserved Quantity'
      ]], { origin: 'A1' });

      // Center align all cells
      const range = XLSX.utils.decode_range(worksheet['!ref']!);
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          const cell = worksheet[cellAddress];
          if (cell) {
            cell.s = {
              alignment: {
                vertical: 'center',
                horizontal: 'center'
              }
            };
          }
        }
      }

      // Optional column width
      worksheet['!cols'] = [
        { wch: 30 },
        { wch: 20 },
        { wch: 18 },
        { wch: 18 },
        { wch: 18 }
      ];

      const workbook = {
        Sheets: { Variants: worksheet },
        SheetNames: ['Variants']
      };

      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
        cellStyles: true   // IMPORTANT
      });

      saveAs(
        new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }),
        'Product_Variants.xlsx'
      );

      this.toastr.success('Excel file downloaded successfully');

    } catch (error) {
      console.error('Excel download error:', error);
      this.toastr.error('Failed to download Excel file');

    } finally {
      this.spinner.hide();
    }
  }


  downloadPdf() {
    try {
      this.spinner.show();

      const data = this.getDownloadData();

      if (!data.length) {
        this.toastr.warning('No valid data available to download');
        return;
      }

      const doc = new jsPDF('p', 'mm', 'a4');

      const tableBody = data.map(item => [
        item.productName,
        item.barcodeNumber,
        item.actualQty,
        item.currentQty,
        item.reservedQty
      ]);

      autoTable(doc, {
        head: [[
          'Product Name',
          'Barcode',
          'Actual Qty',
          'Current Qty',
          'Reserved Qty'
        ]],
        body: tableBody,
        startY: 20,
        theme: 'grid',

        // Center alignment
        styles: {
          fontSize: 9,
          cellPadding: 3,
          halign: 'center',
          valign: 'middle'
        },
        headStyles: {
          fillColor: [220, 53, 69],
          halign: 'center'
        },

        pageBreak: 'auto',
        rowPageBreak: 'avoid',

        didDrawPage: () => {
          doc.setFontSize(12);
          doc.text('Product Variant Stock Report', 14, 12);
        }
      });

      doc.save('Product_Variants.pdf');

      this.toastr.success('PDF file downloaded successfully');

    } catch (error) {
      console.error('PDF download error:', error);
      this.toastr.error('Failed to download PDF file');

    } finally {
      this.spinner.hide();
    }
  }

  getDownloadData() {
    return this.getAllVariantDetails
      .filter(item =>
        item.reservedQuantity > 0
      )
      .map(item => ({
        productName: item.productName,
        barcodeNumber: item.barcodeNumber,
        actualQty: item.varientQuantity,
        currentQty: item.availableStock,
        reservedQty: item.reservedQuantity
      }));
  }

  trackByVariantId(index: number,item: ProductVariantDetails): number {
  return item.productVariantId;
}

  ngOnDestroy(): void {
  this.destroy$.next(true);
  this.destroy$.complete();
}


}




